import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c75c572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "itemcard wp" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Start browsing here:", -1))
const _hoisted_6 = { class: "policies" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" By using the web-proxy you accept the ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("web-proxy policies")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " About 3.8 billion people are online every day. From sharing content to collecting data for organizational purposes, there are about 2.5 quintillion bytes of data being processed by Google every day. Not all data is available to all people around the world. For example, a show on Netflix in one country may not be available in another country. This is due to restrictions and copyrights imposed by the government of the respective country. Web proxy is the easiest way to access all restricted content without having to install any kind of software.  ", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div data-v-3c75c572><h2 data-v-3c75c572>FAQs:</h2><ul data-v-3c75c572><li data-v-3c75c572><strong data-v-3c75c572>Is ProxyScrape’s web proxy free?</strong><p data-v-3c75c572> It is absolutely free and supports modern websites like YouTube, Twitter, and Google. You just need to paste the link and you are good to go. </p></li><li data-v-3c75c572><strong data-v-3c75c572>What does a web proxy do?</strong><p data-v-3c75c572> Aweb proxy acts as an intermediary between the user and the internet. Taking a request from the user to the targeted website,  receiving the response, and routing it back to the user.  </p></li><li data-v-3c75c572><strong data-v-3c75c572>When is the best time to use a web proxy?</strong><p data-v-3c75c572> Based on your needs. If you don&#39;t want to install software on your local computer, with the help of a web proxy, you can simply type in the website address and get the result. </p></li><li data-v-3c75c572><strong data-v-3c75c572>Does a web proxy affect internet performance?</strong><p data-v-3c75c572> No, a web proxy uses cache memory, which stores the data temporarily about the webpage you visited. If you want to visit that webpage again, the web proxy provides you with a copy of the webpage, which reduces the latency. </p></li></ul></div><h2 data-v-3c75c572>Conclusion:</h2><p data-v-3c75c572> If you are a person who does not want to install dedicated software on your computer for simple web surfing, a web proxy is the best solution for you. Our web proxy provides you the best access to all the restricted sites without compromising on qualities like internet speed and connectivity.  </p>", 3)

import ProxyForm from '@/components/freebies/web/ProxyForm.vue';
import AboutWProxy from '@/components/freebies/web/AboutWProxy.vue';
import WhyWProxy from '@/components/freebies/web/WhyWProxy.vue';
import ProxyVsVpn from '@/components/freebies/web/ProxyVsVpn.vue';
import WProxyFeatures from '@/components/freebies/web/WProxyFeatures.vue';
import BlogSection from '@/components/shared/BlogSection.vue';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Free web proxy',
  subtitle: 'Browse fast & anonymously',
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(ProxyForm),
            _createElementVNode("p", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_link, {
                to: "/web-proxy-policies",
                style: {"text-decoration":"underline"},
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _hoisted_9,
            _hoisted_10,
            _createVNode(AboutWProxy),
            _createVNode(WhyWProxy),
            _createVNode(ProxyVsVpn),
            _createVNode(WProxyFeatures),
            _hoisted_11
          ])
        ]),
        _createVNode(BlogSection)
      ])
    ])
  ]))
}
}

})